

import img5 from './6.jpg';
import img6 from './5.jpg';
import img7 from './4.jpg';
import img8 from './3.jpg';
import img9 from './1.jpg';
import img10 from './2.jpg';





export const img = [ img5,img6, img7, img8, img9, img10]